module.exports = __webpack_public_path__ + "static/img/supersound1.06337dd9.png";